<template>
  <span>
    <v-row>
      <v-spacer></v-spacer>
      <v-col class="text-right">
<!--        <v-btn-->
<!--            class="ma-2"-->
<!--            depressed-->
<!--            outlined-->
<!--            :color="colorActive"-->
<!--            @click="openDialog()"-->
<!--        >-->
<!--          <v-icon left :color="colorActive"> $ic-filter </v-icon>-->
<!--          Filter-->
<!--        </v-btn>-->
      </v-col>
    </v-row>
    <span v-if="dash_active === 'homecharging'">
      <v-row >
        <v-col v-for="(data, i) in summaryCardUnitHC" :key="i" >
          <v-card flat  outlined >
            <v-card-text>
              <div style="display: flex; flex-direction: column; height: 8.5rem; width: auto">
                <span class="summary-title">{{ data.title }}</span>
                <span
                    v-if="data.id === 'UNIT INTEGRASI' "
                    class="summary-value">
                  {{ formatCurrency(data.value.sekarang).split(",")[0] }} unit
                </span>
                <span v-else class="summary-value">
                  {{
                    formatCurrency(data.value.sekarang)
                  }}
                  kWh</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-card flat outlined>
            <v-card-title class="pb-0">
              <p>
                <span style="font-weight: 600"
                >HomeCharging Terintegrasi {{getCurrentYear}}</span
                >
                <span style="font-color: #9a9a9a; font-size: 14px"
                >Data Keseluruhan</span
                >
              </p>
            </v-card-title>
            <v-card-text>
              <span
                  v-if="
                  (this.input.periode === undefined && !isLoading) ||
                  (this.input.periode &&
                    this.input.periode.id === 'hourly' &&
                    !isLoading)
                "
              >
                <LineChartGenerator
                    :chart-options="chartOptionsLine"
                    :chart-data="chartLineDataUnit"
                />
              </span>
              <span v-else-if="!isLoading">
                <Bar
                    :chart-options="chartOptionsBar"
                    :chart-data="chartBarDataUnit"
                />
              </span>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="6">
          <v-card flat outlined>
            <v-card-title class="pb-0">
              <p>
                <span style="font-weight: 600"
                >Energi Pemakaian HomeCharging (kWh) {{getCurrentYear}}</span
                >
                <span style="color: #9a9a9a; font-size: 14px"
                >Data Keseluruhan</span
                >
              </p>
            </v-card-title>
            <v-card-text>
              <span
                  v-if="
                  (this.input.periode === undefined && !isLoading) ||
                  (this.input.periode &&
                    this.input.periode.id === 'hourly' &&
                    !isLoading)
                "
              >
                <LineChartGenerator
                    :chart-options="chartOptionsLine"
                    :chart-data="chartLineDataTotalKwh"
                />
              </span>
              <span v-else-if="!isLoading">
                <Bar
                    :chart-options="chartOptionsBar"
                    :chart-data="chartBarDataTotalKwh"
                />
              </span>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="6">
          <v-card flat outlined>
            <v-card-title class="pb-0">
              <p>
                <span style="font-weight: 600"
                >Energi Pemakaian HomeCharging yang mendapatkan diskon (kWh) {{getCurrentYear}}</span
                >
                <span style="color: #9a9a9a; font-size: 14px"
                >Data Keseluruhan</span
                >
              </p>
            </v-card-title>
            <v-card-text>
              <span
                  v-if="
                  (this.input.periode === undefined && !isLoading) ||
                  (this.input.periode &&
                    this.input.periode.id === 'hourly' &&
                    !isLoading)
                "
              >
                <LineChartGenerator
                    :chart-options="chartOptionsLine"
                    :chart-data="chartLineDataTotalDiskonKwh"
                />
              </span>
              <span v-else-if="!isLoading">
                <Bar
                    :chart-options="chartOptionsBar"
                    :chart-data="chartBarDataTotalDiskonKwh"
                />
              </span>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="6">
          <v-card flat outlined>
            <v-card-title class="pb-0">
              <p>
                <span style="font-weight: 600"
                >HomeCharging Terintegrasi (UID/UIW) {{getCurrentYear}}</span
                >
                <span style="color: #9a9a9a; font-size: 14px"
                >Data Keseluruhan</span
                >
              </p>
            </v-card-title>
            <v-card-text>
              <span
                  v-if="
                  (this.input.periode === undefined && !isLoading) ||
                  (this.input.periode &&
                    this.input.periode.id === 'hourly' &&
                    !isLoading)
                "
              >
                <LineChartGenerator
                    :chart-options="chartOptionsLine"
                    :chart-data="chartLineDataUnitUidUiw"
                />
              </span>
              <span v-else-if="!isLoading">
                <Bar
                    :chart-options="chartOptionsBar"
                    :chart-data="chartBarDataUnitUidUiw"
                />
              </span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </span>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <v-row>
            <v-col>
              <span>Filter Data</span>
            </v-col>
            <v-col class="text-right">
              <v-btn icon x-small @click="closeDialog()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="pb-0 pt-1">
                <div class="label mb-2" :style="'color:' + colorActive">
                  Unit
                </div>
                <v-text-field
                    v-model="input.searchBranch"
                    label="Cari Lokasi"
                    dense
                    solo
                    flat
                    outlined
                    clearable
                >
                </v-text-field>
                <span
                >Selected:
                  {{
                    input.branch.name ? input.branch.name : "unit belum dipilih"
                  }}
                  <v-icon
                      v-show="input.branch.id"
                      @click="
                      input.branch = {};
                      active = [];
                    "
                  >mdi-close</v-icon
                  >
                </span>
                <div
                    v-show="!input.branch.id"
                    style="overflow-y: scroll; height: 300px"
                >
                  <v-treeview
                      activatable
                      :active="active"
                      :items="tempOptionsBranch"
                      @update:active="treeClick"
                  ></v-treeview>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pb-0 pt-1">
                <div class="label-custom mb-2" :style="'color:' + colorActive">
                  Nama SPKLU
                </div>
                <v-autocomplete
                    v-model="input.spklu"
                    :items="optionsSpklu"
                    label="Semua SPKLU"
                    dense
                    solo
                    flat
                    outlined
                    item-text="name"
                    item-value="id"
                    return-object
                    :color="colorActive"
                    :search-input.sync="searchSpkluKeyword"
                    :loading="awaitingSearch"
                    clearable
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pb-0 pt-1">
                <div class="label mb-2" :style="'color:' + colorActive">
                  Tipe Periode
                </div>
                <v-autocomplete
                    v-model="input.periode"
                    :items="optionsTipePeriode"
                    label="Semua"
                    dense
                    solo
                    flat
                    outlined
                    item-text="name"
                    item-value="id"
                    return-object
                    cache-items
                    :color="colorActive"
                    @change="changeDateRangeType()"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row
                v-if="this.input.periode && this.input.periode.id !== 'yearly'"
            >
              <v-col class="pb-5 pt-1">
                <div class="label mb-2" :style="'color:' + colorActive">
                  Periode
                </div>
                <v-menu
                    ref="menuDateRange"
                    v-model="menuDateRange"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        :value="formattedDateRange"
                        readonly
                        clearable
                        @click:clear="changeDateRangeType()"
                        v-bind="attrs"
                        v-on="on"
                        dense
                        solo
                        flat
                        outlined
                        hide-details
                        append-icon="mdi-calendar"
                        placeholder="Semua"
                        :color="colorActive"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      reactive
                      v-model="dateRange"
                      :active-picker.sync="activePicker"
                      :max="
                      new Date(
                        Date.now() - new Date().getTimezoneOffset() * 60000
                      )
                        .toISOString()
                        .substr(0, 10)
                    "
                      locale="id-ID"
                      :color="colorActive"
                      :type="dpTypeChooser()"
                      @click:year="
                      input.periode && input.periode.id === 'monthly'
                        ? setDateRange(dateRange)
                        : ''
                    "
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="input.periode && input.periode.id !== 'monthly'"
                        text
                        :color="colorActive"
                        @click="setDateRange"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small depressed color="#999999" text @click="closeDialog()">
            Kembali
          </v-btn>
          <v-btn
              small
              depressed
              :color="colorActive"
              @click="
              dialog = false;
              reGetChart();
            "
              dark
          >
            Cari
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import { Bar, Line as LineChartGenerator } from 'vue-chartjs'
import HomeChargingServices from '@/services/default/HomeChargingServices'
import RefService from '@/services/default/RefService'
import { StorageService } from '@/services/storage.service'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler
} from 'chart.js'

const dashboardHCService = HomeChargingServices.build()
const refService = RefService.build()

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler
)
export default {
  name: 'Dashboard-SPKLU',
  components: {
    Bar,
    LineChartGenerator
  },
  data: () => ({
    colorActive: '#2671D9',
    colorInactive: '#9A9A9A',
    dialog: false,
    searchSpkluKeyword: '',
    awaitingSearch: false,
    optionsSpklu: [],
    optionsBranch: [],
    optionsCakupan: [
      { id: 'spklu', name: 'Per SPKLU' },
      { id: 'wilayah', name: 'Per Wilayah' }
    ],
    isShowOptionSpklu: true,
    isShowOptionBranch: true,
    tempOptionsBranch: [],
    optionsTipePeriode: [
      { id: 'hourly', name: 'Hourly' },
      { id: 'daily', name: 'Daily' },
      // { id: 'weekly', name: 'Weekly' },
      { id: 'monthly', name: 'Monthly' },
      { id: 'yearly', name: 'Yearly' }
    ],
    input: {
      cakupan: {},
      periode: { id: 'yearly', name: 'Yearly' },
      branch: {
        id: '',
        name: ''
      },
      searchBranch: '',
      spklu: { id: '', name: '' }
    },
    active: [],
    menuDateRange: false,
    dateRange: null,
    activePicker: null,
    // dashboard spklu variable
    dash_active: 'homecharging',
    // chart properties dashboard spklu
    isLoading: false,
    chartLineDataUnit: {
      // put chart label here (y axis)
      labels: [],
      datasets: [
        {
          label: 'Jumlah Transaksi',
          backgroundColor: '#d4e3f7',
          borderColor: '#2671D9',
          // put chart data here
          data: [],
          fill: 'start',
          tension: 0.4
        }
      ]
    },
    chartBarDataUnit: {
      // put chart label here (y axis)
      labels: [],
      datasets: [
        {
          label: 'Jumlah Transaksi',
          backgroundColor: '#2671D9',
          // put chart data here
          data: [],
          barThickness: 15
        }
      ]
    },

    chartLineDataUnitUidUiw: {
      // put chart label here (y axis)
      labels: [],
      datasets: [
        {
          label: 'Jumlah Transaksi',
          backgroundColor: '#d4e3f7',
          borderColor: '#2671D9',
          // put chart data here
          data: [],
          fill: 'start',
          tension: 0.4
        }
      ]
    },
    chartBarDataUnitUidUiw: {
      // put chart label here (y axis)
      labels: [],
      datasets: [
        {
          label: 'Jumlah Transaksi',
          backgroundColor: '#2671D9',
          // put chart data here
          data: [],
          barThickness: 15
        }
      ]
    },

    chartLineDataTotalKwh: {
      // put chart label here (y axis)
      labels: [],
      datasets: [
        {
          label: 'Jumlah Transaksi',
          backgroundColor: '#d4e3f7',
          borderColor: '#2671D9',
          // put chart data here
          data: [],
          fill: 'start',
          tension: 0.4
        }
      ]
    },
    chartBarDataTotalKwh: {
      // put chart label here (y axis)
      labels: [],
      datasets: [
        {
          label: 'Jumlah Transaksi',
          backgroundColor: '#2671D9',
          // put chart data here
          data: [],
          barThickness: 15
        }
      ]
    },

    chartLineDataTotalDiskonKwh: {
      labels: [],
      datasets: [
        {
          label: 'Jumlah Transaksi',
          backgroundColor: '#d4e3f7',
          borderColor: '#2671D9',
          // put chart data here
          data: [],
          fill: 'start',
          tension: 0.4
        }
      ]
    },
    chartBarDataTotalDiskonKwh: {
      labels: [],
      datasets: [
        {
          label: 'Jumlah Transaksi',
          backgroundColor: '#2671D9',
          // put chart data here
          data: [],
          barThickness: 15
        }
      ]
    },

    chartOptionsLine: {
      responsive: true,
      maintainAspectRatio: true,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              let label = context.dataset.label || ''

              if (label) {
                label += ': '
              }
              if (context.parsed.y !== null) {
                const isHasDecimal =
                    context.parsed.y - Math.floor(context.parsed.y) !== 0
                // Indonesian's number format
                if (isHasDecimal) {
                  const value = (context.parsed.y / 1)
                    .toFixed(2)
                    .replace('.', ',')
                  label += value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                } else {
                  label += context.parsed.y
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                }
              }
              return label
            }
          }
        }
      },
      scales: {
        y: {
          ticks: {
            // Indonesian's number format
            callback: (label) =>
                `${label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`
          }
        }
      }
    },
    chartLineDataKwh: {
      // put chart label here (y axis)
      labels: [],
      datasets: [
        {
          label: 'kWh Terjual',
          backgroundColor: '#d4e3f7',
          borderColor: '#2671D9',
          // put chart data here
          data: [],
          fill: 'start',
          tension: 0.4
        }
      ]
    },
    chartBarDataKwh: {
      // put chart label here (y axis)
      labels: [],
      datasets: [
        {
          label: 'kWh Terjual',
          backgroundColor: '#2671D9',
          // put chart data here
          data: [],
          barThickness: 15
        }
      ]
    },
    chartOptionsBar: {
      responsive: true,
      maintainAspectRatio: true,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              let label = context.dataset.label || ''

              if (label) {
                label += ': '
              }
              if (context.parsed.y !== null) {
                const isHasDecimal =
                    context.parsed.y - Math.floor(context.parsed.y) !== 0
                // Indonesian's number format
                if (isHasDecimal) {
                  const value = (context.parsed.y / 1)
                    .toFixed(2)
                    .replace('.', ',')
                  label += value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                } else {
                  label += context.parsed.y
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                }
              }
              return label
            }
          }
        }
      },
      scales: {
        y: {
          ticks: {
            // Indonesian's number format
            callback: (label) =>
                `${label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`
          }
        }
      }
    },
    summaryCardUnitHC: [
      { id: 'KWH TOTAL', title: 'Energi Pemakaian Home Charging (kWh) 2024', value: 0 },
      { id: 'DISCOUNT KWH TOTAL', title: 'Energi Pemakaian Home Charging yang mendapatkan diskon (kWh) 2024', value: 0 },
      { id: 'UNIT INTEGRASI', title: 'Home Charging Terintegrasi 2024', value: 0 }
    ],
    summaryPercentage: [
      {
        id: 'daily',
        textLeft: 'Pendapatan Harian',
        textRight: 'Hari Sebelumnya Rp ',
        incomeNow: 0,
        incomeBefore: 0,
        percentage: 0
      },
      {
        id: 'weekly',
        textLeft: 'Pendapatan Mingguan',
        textRight: 'Minggu Sebelumnya Rp ',
        incomeNow: 0,
        incomeBefore: 0,
        percentage: 0
      },
      {
        id: 'monthly',
        textLeft: 'Pendapatan Bulanan',
        textRight: 'Bulan Sebelumnya Rp ',
        incomeNow: 0,
        incomeBefore: 0,
        percentage: 0
      },
      {
        id: 'yearly',
        textLeft: 'Pendapatan Tahunan',
        textRight: 'Tahun Sebelumnya Rp ',
        incomeNow: 0,
        incomeBefore: 0,
        percentage: 0
      }
    ],
    summaryStatus: [
      { id: 'Aktif', spklu: 0, charger: 0, connector: 0 },
      { id: 'Non Aktif', spklu: 0, charger: 0, connector: 0 },
      { id: 'SPKLU Non PLN', spklu: 0, charger: 0, connector: 0 }
    ],
    getCurrentYear: null
  }),
  async created  () {
    // await this.reGetChart()
    this.currentYear()
  },
  computed: {
    formattedDateRange () {
      if (this.dateRange) {
        if (this.input.periode.id === 'monthly') {
          return this.dateRange.split('-')[0]
        } else if (
          this.input.periode.id === 'hourly' ||
            this.input.periode.id === 'daily'
        ) {
          return this.dateRange
        } else if (this.input.periode.id === 'weekly') {
          return this.dateRange.join(' ~ ')
        }
      }
      return ''
    }
  },
  mounted: async function () {
    const responseAuth = await StorageService.getAuthdata()
    const newVal = this.input.branch.id
    const oldVal = responseAuth.branch.idBranch


    if (newVal === '') {
      if (responseAuth.branch.name !== 'PUSAT') {
        this.input.branch.id = responseAuth.branch.idBranch
        this.input.branch.name = responseAuth.branch.name
      }
      await this.getOptionsSpklu(oldVal)
      await this.reGetChart()
    }
  },
  watch: {
    menuDateRange (val) {
      if (this.input.periode.id === 'monthly') {
        val && this.$nextTick(() => (this.activePicker = 'YEAR'))
      } else if (this.input.periode.id === 'daily') {
        val && this.$nextTick(() => (this.activePicker = 'MONTH'))
      } else if (this.input.periode.id === 'hourly') {
        val && this.$nextTick(() => (this.activePicker = 'DATE'))
      } else {
        val && this.$nextTick(() => (this.activePicker = null))
      }
    },
    // searchSpkluKeyword (val) {
    //   const self = this
    //   if (!this.awaitingSearch) {
    //     setTimeout(() => {
    //       if (val !== '' && val !== null) {
    //         self.getOptionsSpklu()
    //       }
    //       self.awaitingSearch = false
    //     }, 1000)
    //   }
    //   this.awaitingSearch = true
    // },
    'input.searchBranch': function (val) {
      if (!val) {
        this.tempOptionsBranch = this.optionsBranch
      } else {
        this.tempOptionsBranch = this.containComplex(this.optionsBranch, val)
      }
    },
    'input.branch': function (newVal, oldVal) {
      if (newVal.id !== oldVal) {
        this.getOptionsSpklu(newVal.id)
      }
    }
    // 'input.cakupan': function (val) {
    //   if (val.id === 'spklu') {
    //     this.isShowOptionSpklu = true
    //     this.isShowOptionBranch = false
    //   } else if (val.id === 'wilayah') {
    //     this.isShowOptionSpklu = false
    //     this.isShowOptionBranch = true
    //   } else {
    //     this.isShowOptionSpklu = true
    //     this.isShowOptionBranch = true
    //   }
    // }
  },
  methods: {
    currentYear () {
      this.getCurrentYear = new Date().getFullYear()
    },

    closeDialog () {
      this.dialog = false
      this.isLoading = false
    },
    openDialog () {
      this.getOptionsBranch()
      this.dialog = true
      this.isLoading = true
    },
    setDateRange (date) {
      this.$refs.menuDateRange.save(date)
    },
    async getCardData (param) {
      const response = await dashboardHCService.getCardHomeCharging(param)
      // console.log('response Card =>', response)
      const { data } = response
      if (data.success !== true) return
      for (let i = 0; i < this.summaryCardUnitHC.length; i++) {
        this.summaryCardUnitHC[i].value = data.data[i]
      }
    },

    async getChartDataUnit (param) {
      const response = await dashboardHCService.getChartUnitHC(param)
      const { data } = response
      // console.log('response Cart =>', data)
      if (
        this.input.periode === undefined ||
            this.input.periode.id === 'hourly'
      ) {
        this.chartLineDataUnit.datasets[0].data = []

        // set data and y axis label for chart line
        for (let i = 0; i < data.data.length; i++) {
          // hours label format
          this.chartLineDataUnit.datasets[0].data.push(
            data.data[i].unit
          )
        }
      } else {
        this.chartBarDataUnit.datasets[0].data = []

        // set data and y axis label for chart bar
        for (let i = 0; i < data.data.length; i++) {
          const label = data.data[i].year

          this.chartBarDataUnit.labels.push(label)
          this.chartBarDataUnit.datasets[0].data.push(
            data.data[i].unit
          )
        }
      }
    },

    async getChartDataUnitUidUiw () {
      const responseAuth = await StorageService.getAuthdata()
      let q = ''

      if (responseAuth.branch.idBranch !== '1' && responseAuth.branch.idBranch !== '0') {
        q = responseAuth.branch.idBranch
      }

      const param = {
        q: q
      }

      const response = await dashboardHCService.getChartUnitHC(param)
      const { data } = response

      if (
        this.input.periode === undefined ||
            this.input.periode.id === 'hourly'
      ) {
        this.chartLineDataUnitUidUiw.datasets[0].data = []

        // set data and y axis label for chart line
        for (let i = 0; i < data.data.length; i++) {
          // hours label format
          this.chartLineDataUnitUidUiw.datasets[0].data.push(
            data.data[i].unit
          )
        }
      } else {
        this.chartBarDataUnitUidUiw.datasets[0].data = []

        // set data and y axis label for chart bar
        for (let i = 0; i < data.data.length; i++) {
          const label = data.data[i].year

          this.chartBarDataUnitUidUiw.labels.push(label)
          this.chartBarDataUnitUidUiw.datasets[0].data.push(
            data.data[i].unit
          )
        }
      }
    },

    async getChartTotalKwh (param) {
      const response = await dashboardHCService.getChartTotalKwhHC(param)
      const { data } = response
      // console.log('response Chart Total Kwh =>', data)

      if (
        this.input.periode === undefined ||
          this.input.periode.id === 'hourly'
      ) {
        this.chartLineDataTotalKwh.datasets[0].data = []

        // set data and y axis label for chart line
        for (let i = 0; i < data.data.length; i++) {
          // hours label format
          this.chartLineDataTotalKwh.datasets[0].data.push(
            data.data[i].totalKwh
          )
        }
      } else {
        this.chartBarDataTotalKwh.datasets[0].data = []

        // set data and y axis label for chart bar
        for (let i = 0; i < data.data.length; i++) {
          const label = data.data[i].year

          this.chartBarDataTotalKwh.labels.push(label)
          this.chartBarDataTotalKwh.datasets[0].data.push(
            data.data[i].totalKwh
          )
        }
      }
    },

    async getChartTotalDiskonKwh (param) {
      const response = await dashboardHCService.getChartDiskonTotalKwhHC(param)
      const { data } = response
      // console.log('response Chart diskon Total Kwh =>', data)

      if (
        this.input.periode === undefined ||
          this.input.periode.id === 'hourly'
      ) {
        this.chartLineDataTotalDiskonKwh.datasets[0].data = []

        // set data and y axis label for chart line
        for (let i = 0; i < data.data.length; i++) {
          // hours label format
          this.chartLineDataTotalDiskonKwh.datasets[0].data.push(
            data.data[i].discountKwh
          )
        }
      } else {
        this.chartBarDataTotalDiskonKwh.datasets[0].data = []

        // set data and y axis label for chart bar
        for (let i = 0; i < data.data.length; i++) {
          const label = data.data[i].year

          this.chartBarDataTotalDiskonKwh.labels.push(label)
          this.chartBarDataTotalDiskonKwh.datasets[0].data.push(
            data.data[i].discountKwh
          )
        }
      }
    },

    async reGetChart () {
      const dateNow = new Date().toISOString().split('T')[0]
      let q = ''
      const periode = this.formattedDateRange
        ? this.formattedDateRange.split('-').join('')
        : dateNow.split('-').join('')

      if (this.input.spklu) {
        q = this.input.spklu.id
      } else if (this.input.branch) {
        q = this.input.branch.id
      }

      const param = {
        periodeType: this.input.periode.id,
        periode: periode,
        q: q
      }

      await this.getCardData(param)
      await this.getChartDataUnit(param)
      await this.getChartTotalKwh(param)
      await this.getChartTotalDiskonKwh(param)
      await this.getChartDataUnitUidUiw()
      // await this.getTransactionPercentage(param)
      // await this.getStatusData({ q: param.q })
      this.isLoading = false
    },
    colorPicker (status) {
      if (status === 'Aktif') return '#397E5D'
      else if (status === 'Non Aktif') return '#DD6068'
      else return '#2671D9'
    },
    async getOptionsSpklu (id) {
      this.paging.page = 0
      this.paging.size = 20

      // const param = Object.assign({ q: this.searchSpkluKeyword }, this.paging)
      const param = Object.assign({ q: id }, this.paging)
      const response = await refService.getSpkluList(param)
      const { data } = response
      if (data.success !== true) return

      if (this.input.branch.id !== param.q || param.q === undefined) {
        this.optionsSpklu = []
      } else {
        this.optionsSpklu = data.data.content.map((data) => {
          return {
            id: data.idSpklu,
            name: data.spkluName
          }
        })
      }
    },

    async getOptionsBranch () {
      const branch = JSON.parse(localStorage.getItem('branch_list'))?.data

      if (branch) {
        this.optionsBranch = branch
        this.tempOptionsBranch = branch
      } else {
        const param = {
          companyId: 1,
          branchId: ''
        }
        const response = await refService.getBranchList(param)
        const {
          data: { data }
        } = response

        const temp = data.map((item) => {
          // remap level 1
          item.child = item.child.map((item2) => {
            // remap level 2
            item2.child = item2.child.map((item3) => {
              // remap level 3
              item3.child = item3.child.map((item4) => {
                // remap level 4
                return {
                  id: item4.id,
                  name: item4.id.split('').join('.') + ' - ' + item4.name,
                  children: item4.child
                }
              })
              return {
                id: item3.id,
                name: item3.id.split('').join('.') + ' - ' + item3.name,
                children: item3.child
              }
            })
            return {
              id: item2.id,
              name: item2.id.split('').join('.') + ' - ' + item2.name,
              children: item2.child
            }
          })
          return {
            id: item.id,
            name: item.id.split('').join('.') + ' - ' + item.name,
            children: item.child
          }
        })

        this.optionsBranch = temp
        this.tempOptionsBranch = temp

        localStorage.setItem(
          'branch_list',
          JSON.stringify({
            data: temp
          })
        )
      }
    },
    treeClick (value) {
      if (value.length > 0) {
        const branch = JSON.parse(localStorage.getItem('branch_list'))?.data
        this.input.branch = this.findComplex(branch, value[0])
        this.input.spklu = {}
      }
    },
    changeDateRangeType () {
      // this.dateRange = null
      // if (this.input.periode.id === 'hourly' || this.input.periode.id === 'daily' || this.input.periode.id === 'monthly' || this.input.periode.id === 'yearly') {
      //   this.dateRange = null
      // } else {
      //   // for weekly
      //   this.dateRange = []
      // }
    },
    dpTypeChooser () {
      if (
        (this.input.periode && this.input.periode.id === 'monthly') ||
          (this.input.periode && this.input.periode.id === 'hourly')
      ) {
        return undefined
      } else if (this.input.periode && this.input.periode.id === 'daily') {
        return 'month'
      } else return 'date'
    }
  }
}
</script>
<style scoped>
.summary-title {
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  padding: 5% 5% 0% 5%;
}

.summary-value {
  font-weight: 600;
  font-size: 24px;
  color: #333333;
  padding: 10% 5% 0% 5%;
}

p span {
  display: block;
}

.percentage-value {
  font-weight: 700;
  font-size: 14px;
  color: #333333;
}

.percentage-up {
  font-weight: 600;
  font-size: 14px;
  align-items: center;
  color: #56a452;
}

.percentage-down {
  font-weight: 600;
  font-size: 14px;
  align-items: center;
  color: #dd6068;
}

.summary-alert-title {
  font-weight: 400;
  font-size: 14px;
  color: #9a9a9a;
}

.summary-alert-value {
  font-weight: 600;
  font-size: 18px;
  color: #000000;
}
</style>
